<template>
  <div class="basic-info">
    <header class="topic-title">基本信息</header>
    <main>
      <info-row label="项目状态">
        <span class="status-icon" :style="{ 'border-color': statusColor }"></span>
        {{ projectInfo.statusValue }}
      </info-row>
      <info-row label="状态描述">
        {{ projectInfo.statusDesc }}
      </info-row>
    </main>
  </div>
</template>

<script>
import InfoRow from "./components/InfoRow"
import { projectStatus } from "~/data/project"

export default {
  name: "basic-info",
  components: { InfoRow },
  props: {
    projectInfo: Object
  },
  computed: {
    statusColor() {
      let status = projectStatus.find(i => i.value == this.projectInfo.statusValue)
      return status?.color
    }
  }
}
</script>

<style lang="scss" scoped>
.basic-info {
  ::v-deep .info-row {
    .content {
      display: flex;
      align-items: center;
    }
  }
  .status-icon {
    display: inline-flex;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    border: 4px solid;
    line-height: 20px;
    margin-right: 6px;
  }
}
</style>
